import { NgClass } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CategoryViewDto } from '@app/administration/catalog/company/catalog-basic/catalog-basic.component';
import { NgbDropdown } from '@commonNodeModules/@ng-bootstrap/ng-bootstrap';
import { AdministrationCategoryGroupDto } from "@interfaces/HttpClient/CatalogApiModels";
import { FolderState } from '@interfaces/iNode';
import { TranslationService } from '@services/translation.service';
import { timer } from 'rxjs';

@Component({
    selector: 'app-category-list',
    templateUrl: './category-list.component.html',
    styleUrls: ['./category-list.component.scss'],
    imports: [NgClass]
})
export class CategoryListComponent implements OnInit, OnChanges {

	private openFolderIcon = "tree-arrow-down-mask-img";
	private closedFolderIcon = "tree-arrow-right-mask-img";
	public categoryViews: CategoryViewDto[];
	private categoryGroupViews: CategoryViewDto[];
	@Input() dropDown: NgbDropdown;
	@Input() categoryId: number;
	@Input() isOpen: boolean;
	@Input() categoryGroups: AdministrationCategoryGroupDto[];
	@Output() categoryChanged = new EventEmitter();

	constructor(
		private translationService: TranslationService,
		private elRef: ElementRef,
	) { }


	async ngOnInit(): Promise<void> {
		await this.setCategories();
	}

	async ngOnChanges(changes: SimpleChanges): Promise<void> {
		if (changes?.isOpen?.currentValue === true) {
			const subscription = timer(100).subscribe(() => {
				const activeElement = this.elRef.nativeElement.querySelector('.category-list-item.list-group-item.active');
				activeElement?.scrollIntoView({ block: 'center' });
				subscription.unsubscribe();
			})
		}

		await this.setCategories();
	}

	public getTreeCategoryIndent(categoryView: CategoryViewDto) {
		return categoryView.categoryId ? 2 : 1;
	}

	public isTreeCategoryVisible(categoryView: CategoryViewDto) {
		return categoryView.categoryId === undefined || this.categoryGroupViews.find(f => f.groupId === categoryView.groupId).folderState === FolderState.open;
	}

	public treeCategoryClicked(categoryView: CategoryViewDto) {
		if (!categoryView.categoryId) {
			categoryView.folderState = categoryView.folderState === FolderState.close ? FolderState.open : FolderState.close;
		} else {
			this.categoryId = categoryView.categoryId;
			this.categoryChanged.emit({ displayString: categoryView.displayString, categoryId: this.categoryId });
			this.dropDown.close();
		}
	}

	public getTreeCategoryFolderIcon(categoryView: CategoryViewDto) {
		return categoryView.folderState === FolderState.open ? this.openFolderIcon : this.closedFolderIcon;
	}

	private async setCategories() {
		const categoryViews: CategoryViewDto[] = [];
		this.categoryGroupViews = [];

		const selectedCategoryGroupId = this.categoryGroups?.find(cg => cg.categories.find(c => c.id === this.categoryId))?.id;
		this.categoryGroups.forEach(cg => {
			const groupView = { groupId: cg.id, view: this.translationService.getByKey(cg.titleResourceKey), folderState: cg.id === selectedCategoryGroupId ? FolderState.open : FolderState.close }
			categoryViews.push(groupView);
			this.categoryGroupViews.push(groupView);
			cg.categories.forEach(c => {
				const category = {
					groupId: cg.id,
					categoryId: c.id,
					displayString: groupView.view + ' | ' + this.translationService.getByKey(c.titleResourceKey),
					view: this.translationService.getByKey(c.titleResourceKey),
				}
				categoryViews.push(category);
			});
		});

		this.categoryViews = categoryViews;
		this.categoryChanged.emit(this.getCategoryById(this.categoryId));
	}

	public getCategoryById(categoryId: number) {
		return { displayString: this.categoryViews.find(f => f.categoryId === categoryId)?.displayString ?? '', categoryId };
	}

}
